import { CpSetupConsultInterface } from '../../../interfaces/dto/setup-consult/cp-setup-consult-interface';
import { CitiesModel, CountryInfoModel, DistrictsModel } from '@fh-client-interaction-frontends/fh-providers';
import { CpServicesModel } from '../services/cp-services-model';
import { CpSpecialityModel } from '../speciality/cp-speciality-model';
import { CpSubServicesModel } from '../sub-services/cp-sub-services-model';
import { CpRequestFieldsModel } from '../request-fields/cp-request-fields-model';

export class CpSetupConsultModel implements CpSetupConsultInterface {
  city: CitiesModel[] = new Array<CitiesModel>();
  country: CountryInfoModel[] = new Array<CountryInfoModel>();
  country_id: number = -1;
  district: DistrictsModel[] = new Array<DistrictsModel>();
  service: CpServicesModel[] = new Array<CpServicesModel>();
  specialty: CpSpecialityModel[] = new Array<CpSpecialityModel>();
  subService: CpSubServicesModel[] = new Array<CpSubServicesModel>();
  RequestFields: CpRequestFieldsModel[] = [];

  constructor(init?: Partial<CpSetupConsultModel>) {
    Object.assign(this, init);
  }
}
